export default {"src":"/_next/static/media/accident_24.99d4c09a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};